import { render, staticRenderFns } from "./UniqueStartupsTrackedCounterChart.vue?vue&type=template&id=7120ce3c&"
import script from "./UniqueStartupsTrackedCounterChart.vue?vue&type=script&lang=js&"
export * from "./UniqueStartupsTrackedCounterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports